import React, { useCallback, useEffect } from 'react';
import { IKlarityProgramPackageSessionItem } from 'types/programs';
import { getKlaritySessionList } from 'api/operation/programs';

const useGetSessionList = ():[IKlarityProgramPackageSessionItem[]|undefined, boolean, ()=>void] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<IKlarityProgramPackageSessionItem[]>([]);
    const fetchData = useCallback(async () => {
        if (loading) return;
        try {
            setLoading(true);
            const result = await getKlaritySessionList();
            if (!result.error) {
                const resData = result?.data?.data || [];

                setItems(resData);
            }
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    }, [loading]);

    useEffect(() => {
        fetchData();
    }, []);

    return [items, loading, fetchData];
};

export default useGetSessionList;
